import { render } from "./behavior.vue?vue&type=template&id=4eea7e4a"
import script from "./behavior.vue?vue&type=script&lang=js"
export * from "./behavior.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__